import * as React from "react";

interface Props {
  height?: number;
  width?: number;
  color?: string;
}

const Group = ({ height = 800, width = 800, color = 'currentColor', ...props }: Props) => (
  <svg
    fill={color}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    id="folder"
    data-name="Line Color"
    xmlns="http://www.w3.org/2000/svg"
    className="icon line-color"
    {...props}
  >
    <path
      id="primary"
      d="M21,8V19a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V5A1,1,0,0,1,4,4H9.59a1,1,0,0,1,.7.29l2.42,2.42a1,1,0,0,0,.7.29H20A1,1,0,0,1,21,8Z"
      style={{
        fill: "none",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
      }}
    />
  </svg>
);
export default Group;
